// Loaded after the unchanged Swiper 11 bundle. No polling or global Swiper replacement.
(() => {
  if (window.SparksletteSplitSlider) {
    window.SparksletteSplitSlider(document);
    return;
  }
  function init(root) {
    if (typeof Swiper === 'undefined') return;
    root.querySelectorAll('.vca-product-swiper').forEach((slider) => {
      if (slider.swiper) return;
      new Swiper(slider, {
        loop: true,
        slidesPerView: 1,
        speed: 400,
        effect: 'creative',
        creativeEffect: {
          prev: { translate: ['-50%', 0, 0], opacity: 0 },
          next: { translate: ['50%', 0, 0], opacity: 0 },
        },
        pagination: { el: slider.querySelector('.swiper-pagination'), clickable: true },
        grabCursor: true,
      });
    });
  }
  window.SparksletteSplitSlider = init;
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.vca-product-swiper').forEach((slider) => slider.swiper?.destroy(true, true));
  });
})();
